import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import DoneIcon from '@assets/img/icons/done.svg?react';
import cn from 'classnames';

import { toShortNumFormat } from '@/common/lib/toShortNumFormat';
import { StringXSmall } from '@/components/Typography/Typography';
import { Picture } from '@/components/ui/Picture/Picture';

import styles from './styles.module.scss';

import lightPng from '/img/patterns/light.png';
import lightWebp from '/img/patterns/light.webp';

interface RewardDayItemProps {
  day: number;
  value: number;
  status: 'claimed' | 'current' | 'future';
  variant: 'cash' | 'tgem';
  webp: string;
  png: string;
}

const RewardDayItem = forwardRef<HTMLDivElement, RewardDayItemProps>(
  ({ day, status, variant, value, png, webp }, ref) => {
    const { t } = useTranslation();

    return (
      <div
        ref={ref}
        className={cn(
          styles.rewardCard,
          status === 'claimed' && 'opacity-40',
          status === 'current' && styles.active,
          status !== 'claimed' && styles[variant],
        )}
      >
        <StringXSmall className="!text-white/60">
          {t('Day')} {day + 1}
        </StringXSmall>
        {status !== 'claimed' ? (
          <Picture img={png} webp={webp} alt="reward" className="size-10" />
        ) : (
          <DoneIcon className="size-6 my-2" />
        )}
        <StringXSmall weight={'bold'}>+{toShortNumFormat(value)}</StringXSmall>
        <div className={styles.bg} />
        {status === 'current' && (
          <>
            <Picture
              img={lightPng}
              webp={lightWebp}
              alt="light"
              className="z-[-2] h-full top-0 absolute left-1/2 -translate-x-1/2 mix-blend-overlay min-w-max [&>img]:w-auto"
            />
            <div className={styles.smallLight} />
            <div className={styles.bigLight} />
          </>
        )}
      </div>
    );
  },
);

export default RewardDayItem;
